import { Typography, keyframes } from "@mui/material";
import styled from "styled-components";

const pinRipple = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0.6;
  }
  100% {
    transform: translate(-50%, -50%) scale(2);
    opacity: 0;
  }
`;

export const Ripple = styled('span')(({ theme, isPinned }) => ({
  position: 'absolute',
  borderRadius: '50%',
  background: isPinned ? 'rgba(150, 150, 150, 0.4)' : `${theme.palette.primary.main}40`,
  width: 140,
  height: 140,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%) scale(0)',
  pointerEvents: 'none',
  animation: `${pinRipple} 0.6s ease-out`,
}));

const pinPop = keyframes`
 0% {
    transform: rotate(0deg) translateX(0);

  }
  15% {
    transform: rotate(8deg) translateX(0px);
  }
  30% {
    transform: rotate(0deg) translateX(0);
  }
  100% {
    transform: rotate(45deg) translateX(0);
  }
`;

const pinShake = keyframes`
 0% {
    transform: rotate(45deg) translateX(0);
  }
  20% {
    transform: rotate(-5deg) translateX(0);
  }
  40% {
    transform: rotate(10deg) translateX(0);
  }
  60% {
    transform: rotate(-5deg) translateX(0);
  }
  80% {
    transform: rotate(5deg) translateX(0);
  }
  100% {
    transform: rotate(0deg) translateX(0);
  }
`;

// To prevent isDark and isMobile from being passed to the div element
const BaseDiv = ({ isDark, isMobile, ...rest }) => <div {...rest} />;

const StyledCard = styled(BaseDiv)`
  height: ${({ isMobile }) => (isMobile ? 200 : 240)}px;
  border-radius: ${({ isMobile }) => (isMobile ? "12px" : "16px")};
  background-color: ${({ theme }) => theme.palette.background.paper};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  display: flex;
  flex-direction: column;
  justify-content: center;

  &:hover {
    box-shadow: ${({ isDark }) =>
    isDark
      ? "0 8px 20px rgba(255,255,255,0.08)"
      : "0 8px 20px rgba(0, 0, 0, 0.2)"};
  }
`;

const CardContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  padding: 0 8px;
`;

const IconBox = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${({ gradient }) => gradient};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  margin-bottom: 12px;
`;

const AccentBar = styled.div`
  width: 30px;
  height: 3px;
  min-height: 3px;
  max-height: 3px;
  border-radius: 2px;
  background-color: ${({ color }) => color};
  transition: width 0.2s ease-in-out;
  margin-bottom: 12px;
  ${StyledCard}:hover & {
    width: 45px;
  }
`;

const TitleTypography = styled(Typography)`
  font-size: 1.1rem;
  font-weight: bold;
  display: flex;
  justify-content: end;
  padding-bottom: 12px;
`;

export { StyledCard, CardContentBox, IconBox, AccentBar, TitleTypography,pinPop, pinShake };
